import {isNil} from 'ramda';

import {VehiclePhotoResponseBody} from '@dms/api/shared';

import {getGridServiceAlbumPhotos} from '../../../utils/getGridPhotos';
import {ServiceCasePhotoTile} from '../types/ServiceCasePhotoTile';

/**
 * Maps vehicle photos to grid tiles (dedup + weight sort via getGridServiceAlbumPhotos)
 * enriched with the album metadata the cover/delete photo actions need.
 */
export const getServiceCasePhotoTiles = (
  photos: VehiclePhotoResponseBody[]
): ServiceCasePhotoTile[] => {
  const photosById = new Map(photos.map((photo) => [photo.id, photo]));

  return getGridServiceAlbumPhotos(photos).flatMap((gridPhoto) => {
    const source = photosById.get(gridPhoto.id);

    if (isNil(source)) {
      return [];
    }

    return [
      {
        ...gridPhoto,
        fileId: source.fileId,
        albumId: source.albumId,
        isCoverPhoto: source.isCoverPhoto,
      },
    ];
  });
};
